import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';

import { CommonCollections } from '../../App';

const AdminNominationHistoryCell = ({ row }) => {
  const { setNominationId, setNominationHistoryLastConsideredDate } =
    useContext(CommonCollections);
  const { nominationId, candidate, lastConsidered } = row.original;

  const handleClick = () => {
    setNominationId(nominationId);
    setNominationHistoryLastConsideredDate(lastConsidered);
  };

  return (
    <Link to="/form-view-history" onClick={handleClick}>
      <span title={`View ${candidate}`}>
        <i className="bi bi-eye view-button" />
      </span>
    </Link>
  );
};

AdminNominationHistoryCell.propTypes = {
  row: PropTypes.object,
};

export default AdminNominationHistoryCell;
